module.exports = __webpack_public_path__ + "static/media/ColumnCellFlotation_7.6805386a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/ColumnCellFlotation_7.jpg
// module id = 422
// module chunks = 0